
import React, {  useState } from "react";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer.js";
import BlockHeader from "component/BlockHeader/BlockHeader";
import LoginBox from "component/LoginBox/LoginBox";
import { InitiativeSlider, InitiativeListGrouped } from '../../component/InitiativeList';
import { RisingStar } from "component/RisingStar";
import { TalentPoolSlider } from "component/TalentPool";
import stateMap from "../../store/stateMap";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import _ from "lodash";
import { ComponentBridge__HomeBanner } from "component/Bridge";
import { Waypoint } from "react-waypoint";
import { SetTokenizeUser } from "store/dispatcher";
import "./PageHome.scss"
import { FAQList } from "component/FAQ";
import { PagesListSlider } from "component/Pages";
import { PageCredential } from "component/PageCredential";


const HomeCrowdbeesInitiatives = (props) => {
    
    return (
        <div className="crowdbees-initiatives">
            <ul className="initiative-groups">
                <li className="initiative-group type-research">
                    <div className="wrapper">
                        <div className="group-information">
                            <span className="group-icon image-box square contain">
                                <img src={process.env.PUBLIC_URL + '/assets/icon/logo-research.png'} />
                            </span>
                            <h2 className="group-name">Research Activity</h2>
                            <div className="group-desc leading-text">Collaboration between people from similar or other disciplines. Collaborative research help researcher to exchange ideas and create a higher research quality.</div>
                        </div>
                        
                        <div className="view-all-container">
                            <Link
                                className="btn btn-block btn-primary btn-reverse btn-small"
                                to={{
                                    pathname : "research"
                                }}
                            >View Researchs</Link>
                        </div>
                    </div>
                </li>
                <li className="initiative-group type-event">
                    <div className="wrapper">
                        <div className="group-information">
                            <span className="group-icon image-box square contain">
                                <img src={process.env.PUBLIC_URL + '/assets/icon/logo-event.png'} />
                            </span>
                            <h2 className="group-name">Event</h2>
                            <div className="group-desc leading-text">Are you looking for visitors for your event, or meet the best crew to run your event.</div>
                        </div>
                        <div className="view-all-container">
                            <Link
                            className="btn btn-block btn-primary btn-reverse btn-small"
                                to={{
                                    pathname : "event"
                                }}
                            >View Events</Link>
                        </div>
                    </div>
                </li>
                <li className="initiative-group type-talent">
                    <div className="wrapper">
                        <div className="group-information">
                            <span className="group-icon image-box square contain">
                                <img src={process.env.PUBLIC_URL + '/assets/icon/logo-team.png'} />
                            </span>
                            <h2 className="group-name">Talent Team</h2>
                            <div className="group-desc leading-text">Build your dream team by finding the right talent for your project. Choose the talent that suitable with your needs based on their relevant qualifications, skills, and expertise..</div>
                        </div>
                        <div className="view-all-container">
                            <Link
                            className="btn btn-block btn-primary btn-reverse btn-small"
                                to={{
                                    pathname : "talent"
                                }}
                            >View Initiatives</Link>
                        </div>
                    </div>
                </li>
                
            </ul>
        </div>
    )
}

const HomeCrowdbeesPageGroup = () => {
    return (
        <>
            <div className="mb-4">
                <BlockHeader title="Pages" desc="Visit the official pages and find interesting initiatives for you" link={{
                    pathname : "/page"
                }}/>
                <PagesListSlider pages_args={{
                    is_official : 1
                }}/>
            </div>
            <hr/>
            <div>
                <BlockHeader title="Group & Community" desc="Discover and join various groups and communities at BINUS" link={{
                    pathname : "/group"
                }}/>
                <PagesListSlider pages_args={{
                    is_official : 0
                }}/>
            </div>
        </>
    )
}


const PageHome = connect(stateMap)((props) => {
    const [waypointLatest, setWaypointLatest] = useState(false);
    const [waypointRisingStars, setWaypointRisingStars] = useState(false);
    const [waypointFAQ, setWaypointFAQ] = useState(false);
    const [waypointPages, setWaypointPages] = useState(false);

    return (
        <>
            <div id="home-latest-projects">
                <Waypoint onEnter={() => {
                    setWaypointLatest(true);
                }}/>
                <div className="container ">
                    <div className="">
                        <BlockHeader 
                            title="Participate in a Surveys" 
                            desc="Participate in initiatives that include surveys to share your thoughts and earn rewards."
                            link={{
                                pathname : '/initiative'
                            }} />
                            {
                            waypointLatest && 
                            <InitiativeSlider initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                                ,has_survey         : 1
                                // ,hide_passed        : 1
                                ,include_total_joined : false
                                ,incomplete         : 1
                            }} />
                        }
                    </div>
                    <div style={{paddingTop : '78px'}}>
                        <BlockHeader 
                            title="Latest Initiative" 
                            desc="Discover the various exciting initiatives that are being and have been built through Crowdbees."
                            link={{
                                pathname : '/initiative'
                            }} />
                        {
                            waypointLatest && 
                            <InitiativeSlider initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                                ,hide_passed        : 1
                                ,include_total_joined : false
                                ,incomplete         : 1
                            }} />
                        }
                    </div>
                    
                    
                    <Waypoint onEnter={() => {
                        setWaypointRisingStars(true)
                    }}/>
                    <div className="mt-5">
                        <BlockHeader 
                            title="Our Rising Stars" 
                            desc="Our users with the best ratings"
                            link={{
                                pathname : '/rising-star'
                            }}    
                        />
                            
                        {
                            waypointRisingStars &&    
                            <RisingStar listArgs={{
                                posts_per_page : 4
                            }}/>
                        }
                    </div>
                </div>
            </div>
            <div className="container ">
                <Waypoint onEnter={() => {
                    setWaypointPages(true);
                }}/>
                {waypointPages &&<HomeCrowdbeesPageGroup/>}
            </div>
            <Waypoint onEnter={() => {
                setWaypointFAQ(true)
            }}/>
            <div className="container">
                <BlockHeader link={{
                    pathname : "/faq"
                }} title="FAQ" desc="Have Question ? Read our most frequently asked question"/>
                {
                    waypointFAQ && <FAQList sticky="1"/>
                }
            </div>
        </>
    )
});

const PageHomeLoggedin = connect(stateMap)((props) => {
    const [waypointLatest, setWaypointLatest] = useState(false);
    const [waypointRisingStars, setWaypointRisingStars] = useState(false);
    const [waypointRec, setWaypointRec] = useState(false);
    const [waypointPool, setWaypointPool] = useState(false);
    const [waypointPages, setWaypointPages] = useState(false);

    return (
        <>
            <div id="home-latest-projects">
                <div className="container">
                    {/* <BlockHeader 
                        title="On Going Initiative" 
                        desc="Quickly access your active initiative."/>
                    <InitiativeListGrouped
                        list_args={{
                            member_id : props.auth.user.UserID
                            ,incomplete : 1
                        }}
                    /> */}
                    <Waypoint onEnter={() => {
                        setWaypointRec(true)
                    }}/>
                    {
                        waypointRec &&
                        <div id="home-proposed-projects">
                            <BlockHeader 
                                title="Initiatives you might like" 
                                desc="Here are some initiatives that might suit you, join and work hand in hand with fellow BINUSIAN"/>
                            <InitiativeSlider endpoint="/Initiative/Recommendation" token={`Bearer ${props.auth.token}`} />
                        </div>
                    }
                    <Waypoint onEnter={() => {
                        setWaypointLatest(true);
                    }}/>
                    <div className="mt-5">
                        <BlockHeader 
                            title="Participate in a Surveys" 
                            desc="Participate in initiatives that include surveys to share your thoughts and earn rewards."
                            link={{
                                pathname : '/initiative'
                            }} />
                            {
                            waypointLatest && 
                            <InitiativeListGrouped initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                                ,has_survey         : 1
                                // ,hide_passed        : 1
                                ,include_total_joined : false
                                ,incomplete         : 1
                            }} />
                        }
                    </div>
                    <div style={{paddingTop : '76px'}}>
                        <BlockHeader 
                            title="Latest Initiative" 
                            desc="Discover the various exciting initiatives that are being and have been built through Crowdbees."
                            link={{
                                pathname : '/initiative'
                            }} />
                        {
                            waypointLatest && 
                            <InitiativeSlider initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                                ,hide_passed        : 1
                                ,include_total_joined : false
                                ,incomplete         : 1
                            }} />
                        }
                    </div>
                    
                    <div className="mt-5">
                        <Waypoint onEnter={() => {
                            setWaypointRisingStars(true)
                        }}/>
                        <BlockHeader 
                            title="Our Rising Stars" 
                            desc="Our users with the best ratings"
                            link={{
                                pathname : '/rising-star'
                            }}    
                        />
                        {
                            waypointRisingStars && 
                            <RisingStar listArgs={{
                                posts_per_page : 4
                            }}/>
                        }
                    </div>
                    <div className="mt-5">
                        <Waypoint onEnter={() => {
                            setWaypointPages(true);
                        }}/>
                        {waypointPages &&<HomeCrowdbeesPageGroup/>}
                    </div>
                    
                </div>
            </div>

            <div className="container">
                <Waypoint onEnter={() => {
                    setWaypointPool(true);
                }}/>
                <BlockHeader title="Meet The Talent" desc="Meet various talents to work together" link={{
                    pathname : "/talent-pool"
                }}/>
                {
                    waypointPool && 
                    <TalentPoolSlider list_args={{
                        posts_per_page : 4
                        ,include_user_score : 1
                        ,include_bio : 1
                        ,sortby         : 'ActivationDate'
                        ,sort           : 'DESC'
                    }}/>
                }
            </div>
        </>
    )
});

export default connect(stateMap, {SetTokenizeUser})((props) => {
    const [headerBG, setHeaderBG]   = useState(false);
    
    return(
        <>
            <Header background={headerBG}>
                <PageCredential title="Home"/>
                <div className="user-home-intro container">
                    <div className="text-center relative">
                        <p className="app-brief">
                            <span className="variation">Your</span> Talent <span className="variation">Has a Place</span>.<br/> Your Ideas Have a Future.
                            </p>
                        {/* <span className="image-box circle square">
                            {
                                !props.auth.user.UserPhoto ? <InitialsAvatar name={props.auth.user.UserDisplayName} /> 
                                : <img src={props.auth.user.UserPhoto}/>
                            }
                        </span> */}
                        <p className="mt-md leading-text">At Crowdbees, every skill matters, and every initiative deserves to grow.</p>
                        {
                            props.auth.user ?
                            <div className="flex flex-wrap mt-lg h-center">
                                <div>
                                    <Link className="btn btn-primary btn-mini" to={{
                                        pathname : "/create"
                                    }}>Add Initiatives</Link>&nbsp;
                                </div>
                                <div>
                                    <Link className="btn btn-primary btn-reverse btn-mini" to={{
                                        pathname : "/profile"
                                    }}>Complete Portofolios</Link>&nbsp;
                                </div>
                            </div> :
                            <div className="mt-5">
                                <LoginBox buttonOnly={true}/>
                            </div>
                        }
                    </div>
                    <HomeCrowdbeesInitiatives/>
                    <ComponentBridge__HomeBanner/>
                </div>
            </Header>
            {
                !props.auth.fetching && (
                    props.auth.user ? <PageHomeLoggedin/> : <PageHome/>
                )
            }
            <Footer/>
        </>
    )
});